import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import stileGrid from "../../../interfaccia/stileGrid";
import CodiceVSVoceCliccabile from "../../../navigadbsections/CodiceVSVoceCliccabile";
import DatoModificabileInLinea from "../../../navigadbsections/DatoModificabileInLinea";
import TraduciCiecamente from "../../../navigadbsections/TraduciCiecamente";
import RiciclaCiecamente from "../../../navigadbsections/RiciclaCiecamente";
import ForzaSync from "../../../navigadbsections/ForzaSync";
import stilePulsanti from "../../../interfaccia/stilePulsanti";

function ListaArticoliAreaTradFromPS({
  setProductFunction,
  listaArticoli,
  utente,
  setAnteprimaProdotto,
  tradPermessa,
}) {
  const [rows, setRows] = useState(listaArticoli);

  useEffect(() => {
    setRows(listaArticoli);
  }, [listaArticoli]);

  const columns = [
    {
      field: "codiceVS",
      headerName: "VS",
      width: 50,
      renderCell: (params) => {
        if (params.row.codiceVS) {
          return (
            <CodiceVSVoceCliccabile
              codiceVS={params.row.codiceVS}
              setProductFunction={setProductFunction}
              utente={utente}
            />
          );
        } else {
          return <div className="rowitem">X</div>;
        }
      },
    },
    {
      field: "shortName",
      valueGetter: (params) => params.row.shortName?.it ?? "N/A",
      headerName: "S.NAME",
      width: 200,
    },
    {
      field: "codMod",
      /* valueGetter: (params) => params.row.titIT ?? "N/A", */
      headerName: "COD MOD",
      width: 220,
      renderCell: (params) => {
        if (params.row.codMod) {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato={params.row.codMod}
              nomeDato="codiceProduttore.codProduttoreModello"
              setProductFunction={setProductFunction}
            />
          );
        } else {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato=""
              nomeDato="codiceProduttore.codProduttoreModello"
              setProductFunction={setProductFunction}
            />
          );
        }
      },
    },
    {
      field: "titIT",
      /* valueGetter: (params) => params.row.titIT ?? "N/A", */
      headerName: "TIT IT",
      width: 220,
      renderCell: (params) => {
        if (params.row.titIT) {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato={params.row.titIT}
              nomeDato="descrizioniSuPS.titolo.it"
              setProductFunction={setProductFunction}
            />
          );
        } else {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato=""
              nomeDato="descrizioniSuPS.titolo.it"
              setProductFunction={setProductFunction}
            />
          );
        }
      },
    },
    {
      field: "titEN",
      /* valueGetter: (params) => params.row.descrizioniSuPS?.titolo?.en ?? "N/A", */
      headerName: "TIT EN",
      /* headerClassName: 'fw7', */
      width: 220,
      renderCell: (params) => {
        if (params.row.titEN) {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato={params.row.titEN}
              nomeDato="descrizioniSuPS.titolo.en"
              setProductFunction={setProductFunction}
            />
          );
        } else {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato=""
              nomeDato="descrizioniSuPS.titolo.en"
              setProductFunction={setProductFunction}
            />
          );
        }
      },
    },
    {
      field: "titFR",
      /* valueGetter: (params) => params.row.descrizioniSuPS?.titolo?.fr ?? "N/A", */
      headerName: "TIT FR",
      /* headerClassName: 'fw7', */
      width: 220,
      renderCell: (params) => {
        if (params.row.titFR) {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato={params.row.titFR}
              nomeDato="descrizioniSuPS.titolo.fr"
              setProductFunction={setProductFunction}
            />
          );
        } else {
          return (
            <DatoModificabileInLinea
              idDocumento={params.row._id}
              dato=""
              nomeDato="descrizioniSuPS.titolo.fr"
              setProductFunction={setProductFunction}
            />
          );
        }
      },
    },
    {
      field: "lunghezzaDescLungaIT",
      valueGetter: (params) => params.row.lunghezzaDescLungaIT ?? "N/A",
      headerName: "#char",
      width: 60,
    },
    {
      field: "startDescLungaFR",
      valueGetter: (params) =>
        params.row.startDescLungaFR === "..."
          ? ""
          : params.row.startDescLungaFR ?? "N/A",
      headerName: "FR desc",
      width: 400,
    },
    {
      field: "_id",
      headerName: "",
      width: 40,
      renderCell: (params) => {
        const cambiaStato = function () {
          params.row.tradotto.en = true;
          setRows([...rows]);
        };
        if (!params.row.tradotto) {
          params.row.tradotto = {
            en: params.row.tradEN,
          };
        }
        if (tradPermessa) {
          return (
            <TraduciCiecamente
              idProd={params.row._id}
              trad={params.row.tradotto?.en || false}
              setProductFunction={setProductFunction}
              cambiaStato={cambiaStato}
              nonAprireDopoTrad={true}
              utente={utente}
            />
          );
        } else {
          return <div>{stilePulsanti.bloccoTradAspetto}</div>;
        }
      },
    },
    /* {
      field: 'hashDescLunga',
      valueGetter: (params) => params.row.hashDescLunga.slice(-5) || "N/A",
      headerName: 'hash',
      width: 70,
    }, */
    {
      field: "hashDescLunga",
      headerName: "hash",
      width: 70,
      renderCell: (params) => {
        if (params.row.hashDescLunga) {
          function getColorFromSeed(seed) {
            if (!seed) return null;

            let hash = 0;
            for (let i = 0; i < seed.length; i++) {
              hash = seed.charCodeAt(i) + ((hash << 5) - hash);
            }

            // Convert the hash to an RGB color
            const r = (hash >> 16) & 0xff;
            const g = (hash >> 8) & 0xff;
            const b = hash & 0xff;

            // Return the color in HEX format
            return `#${((1 << 24) + (r << 16) + (g << 8) + b)
              .toString(16)
              .slice(1)}`;
          }
          const backgroundColor = getColorFromSeed(params.row.hashDescLunga);
          return (
            <div
              style={{
                width: "200px",
                height: "200px",
                backgroundColor: backgroundColor || "transparent",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #ccc",
              }}
            >
              {backgroundColor
                ? `${params.row.hashDescLunga.slice(-5)}`
                : "N/A"}
            </div>
          );
        } else {
          return <div></div>;
        }
      },
    },
    {
      field: "_id2",
      headerName: "ricicla",
      width: 200,
      renderCell: (params) => {
        const cambiaStato = function (prodotto) {
          setRows((correnti) => correnti.map((row) =>
            row._id === params.row._id ? { ...row, tradotto: prodotto.tradotto } : row
          ));
        };
        return (
          <RiciclaCiecamente
            idProd={params.row._id}
            trad={params.row.tradotto.en}
            setProductFunction={setProductFunction}
            utente={utente}
            cambiaStato={cambiaStato}
          />
        );
      },
    },
    {
      field: "_id3",
      headerName: "forza",
      width: 200,
      renderCell: (params) => {
        const cambiaStato = function () {
          params.row.tradotto.en = true;
          setRows([...rows]);
        };
        return (
          <ForzaSync
            idProd={params.row._id}
            codVS={params.row.codiceVS}
            codPS={params.row.codicePS}
            trad={!params.row.tradotto.en} //CAMBIARE IL MODO IN CUI VIENE ATTIVATO/DISATTIVATO!
            setProductFunction={setProductFunction}
            utente={utente}
            cambiaStato={cambiaStato}
          />
        );
      },
    },
  ];

  return (
    <div className="colonnaTuttaPagina">
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
        autoPageSize
        rowsPerPageOptions={[10, 20, 50]}
        pagination
        sx={stileGrid}
      />
    </div>
  );
}

export default ListaArticoliAreaTradFromPS;
